import { projectDetailSearchFields, projectGeneralFields } from '../../common/forms/projects/fields'

export const PROJECT_VALUE_ENDPOINTS = {
    status: 'v1/project/values/projectStatus',
    type: 'v1/project/values/projectType',
    subType: 'v1/project/values/projectSubType',
    energyEfficiency: 'v1/property/values/propertyEnergyEfficiency',
    city: 'v1/core/locations/values/city',
} as const

export const projectGeneralFieldsConfig = {
    status: projectGeneralFields.PROJECT_STATUS_ID,
    type: projectGeneralFields.PROJECT_TYPE_ID,
    subType: projectGeneralFields.PROJECT_SUBTYPE_ID,
    energyEfficiency: projectGeneralFields.PROJECT_ENERGY_EFFICIENCY_ID,
}

// Project Detail Search form field mappings
export const projectDetailSearchFieldsConfig = {
    type: projectDetailSearchFields.PROJECT_TYPE,
    status: projectDetailSearchFields.PROJECT_STATUS,
    city: projectDetailSearchFields.CITY,
}
